'use strict';

class MobileTables {
    constructor(_window = window) {
        this.window = _window;
    }

    init() {
        this.scrollingTables = document.querySelectorAll('table[data-smallscreen="scrolling"]');
        this.boxesTables = document.querySelectorAll('table[data-smallscreen="boxes"]');

        this.checkScrollingTables();
        this.window.addEventListener('resize', () => { this.checkScrollingTables(); });

        this.setupBoxesTables();
    }

    checkScrollingTables() {
        this.scrollingTables.forEach(table => {
            if (table.querySelector('tbody').offsetWidth > table.parentNode.offsetWidth) {
                table.classList.add('js-is-scrolling');
            } else {
                table.classList.remove('js-is-scrolling');
            }
        });
    }

    setupBoxesTables() {
        for (let i = 0, il = this.boxesTables.length; i < il; i++) {
            const trs = this.boxesTables[i].querySelectorAll('tr');
            let headerRow;

            if ([].slice.call(trs[0].cells).filter(cell => cell.tagName === 'TH').length === trs[0].cells.length) {
                headerRow = trs[0];
            }

            if (headerRow) {
                for (let j = 1, jl = trs.length; j < jl; j++) {
                    [].slice.call(trs[j].cells).forEach((td, index) => {
                        td.setAttribute('data-heading', headerRow.cells[index].innerText);
                        td.style.minHeight = (parseInt(window.getComputedStyle(td, ':before').getPropertyValue('height')) +
                            parseInt(window.getComputedStyle(td).getPropertyValue('padding-top')) +
                            parseInt(window.getComputedStyle(td).getPropertyValue('padding-bottom'))
                        ).toString() + 'px';
                    });
                }
            }
        }
    }
}

const components = {
    MobileTables,
};

// Similar to gov.uk approach, allow DS to be applied in a more targeted way than the whole document if needed
// defaults to document
function initAll(scope = document) {

    const tables = [].slice.call(scope.querySelectorAll('table[data-smallscreen]'));
    if (tables.length) {
        const mobileTables = new MobileTables();
        mobileTables.init();
    }
}

initAll(document);